import TransmedProcessSlide from "./slide";

function TransmedProcessNoPlace() {
  return (
    <TransmedProcessSlide>
      <h3>S-au terminat locurile</h3>
      <span style={{ marginTop: "var(--gap-big)" }}>
        Din păcate nu ai avut un punctaj suficient de ridicat, iar locurile s-au
        epuizat înainte să-ți fie rândul să alegi! Totuși, curând urmează o nouă
        ediție transmed. Te așteptăm să participi și atunci și poate vei avea
        mai mult noroc!
      </span>
    </TransmedProcessSlide>
  );
}

export default TransmedProcessNoPlace;
